import { render, staticRenderFns } from "./ProducerList.vue?vue&type=template&id=17e0f6ae"
import script from "./ProducerList.vue?vue&type=script&lang=js"
export * from "./ProducerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17e0f6ae')) {
      api.createRecord('17e0f6ae', component.options)
    } else {
      api.reload('17e0f6ae', component.options)
    }
    module.hot.accept("./ProducerList.vue?vue&type=template&id=17e0f6ae", function () {
      api.rerender('17e0f6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/producers/ProducerList.vue"
export default component.exports